import React from 'react';

const Container = ({ children, className = '', maxWidth = 'max-w-6xl' }) => {
  return (
    <div className={`container mx-auto ${maxWidth} ${className}`}>
      {children}
    </div>
  );
};

export default Container;

